/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from "react";
import { makeStyles } from "@mui/styles";
import { colors } from "common";
import { Theme } from "@mui/material/styles";
import BazarImage from "components/BazarImage";

const useStyles = makeStyles(
  (theme: Theme) => ({
    root: {
      position: "relative",
      height: 480,
    },
    header: {
      position: "absolute",
      borderRadius: 5,
      padding: theme.spacing(1),
      left: theme.spacing(2),
      top: theme.spacing(2),
    },
    backBtnContainer: {
      marginTop: theme.spacing(1),
      padding: theme.spacing(1),
      borderRadius: 5,
      backgroundColor: "rgba(0, 0, 0, 0.25)",
    },
    goBackTxt: {
      color: colors.common.white,
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: 0.5,
      marginLeft: theme.spacing(1),
    },
    coverImg: {
      width: "100%",
      height: 400,
      objectFit: "cover",
      borderBottom: "2px solid",
      borderBottomColor: colors.primary,
      backgroundColor: colors.primary,
    },
    badgeContainer: {
      backgroundColor: colors?.primary,
      height: 150,
      width: 150,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      border: "2px solid",
      borderColor: theme.palette.background.default,
      borderRadius: 10,
      position: "absolute",
      left: theme.spacing(10),
      bottom: theme.spacing(0),
    },
    logo: {
      backgroundColor: "rgba(0, 0, 0, 0.25)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderColor: theme.palette.background.default,
      borderRadius: 5,
    },
    badge: {
      width: undefined,
      height: 150,
    },
  }),
  { index: 999 }
);

const component = ({ cover, badge }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const classes = useStyles();

  const [coverImgErr, setCoverImgErr] = useState("");
  const [badgeImgErr, setBadgeImgErr] = useState("");

  return (
    <div className={classes.root}>
      <BazarImage
        id="cover"
        alt="cover"
        className={classes.coverImg}
        src={cover || coverImgErr || ""}
        onError={() => setCoverImgErr("/assets/images/logo.png")}
      />
      {badge ? (
        <div className={classes.badgeContainer}>
          <BazarImage
            alt="badge"
            src={badge || badgeImgErr}
            className={classes.badge}
            onError={() => setBadgeImgErr("/assets/images/logo.png")}
          />
        </div>
      ) : null}
    </div>
  );
};

export const BuildGalleryCoverAndIcon = React.memo(component);
